import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MaterializeModule } from 'ng2-materialize';


import { MatFormFieldModule, MatInputModule } from '@angular/material';
import { MatAutocompleteModule} from '@angular/material/autocomplete';

import { AppComponent } from './app.component';
import { DboxScatterComponent } from 'app/dboxScatter/dboxScatter.component';
import { DboxRadarComponent } from 'app/dboxRadar/dboxRadar.component';
import { DboxMapComponent } from 'app/dboxMap/dboxMap.component';
import { DboxBarsComponent } from 'app/dboxBars/dboxBars.component';

@NgModule({
  declarations: [
    AppComponent,
    DboxScatterComponent,
    DboxRadarComponent,
    DboxMapComponent,
    DboxBarsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MaterializeModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/app.module.ts